import { Injectable } from '@angular/core';
import Cache from '@aws-amplify/cache';


@Injectable()
export class CacheService {

  static case_data: any;
  static caseContacts: any;
  constructor() { }
  private getItem(key) {
    return Cache.getItem(key);
  }
  private setItem(key, value: any, expiration) {
    return Cache.setItem(key, value, { expires: expiration.getTime() });
  }
  private removeItem(key) {
    Cache.removeItem(key);

  }

  get(key) {
    return this.getItem(key);
  }

  set(key, value: any , expiration) {
    return this.setItem(key, value, expiration);
  }
  remove(key) {
    return this.removeItem(key)
  }

}



// WEBPACK FOOTER //
// ./src/app/services/cache.service.ts